enum TextFieldTypeEnum {
  DATE = 'date',
  DATETIME = 'datetime-local',
  TEXT = 'text',
  NUMBER = 'number',
  PASSWORD = 'password',
}

export default TextFieldTypeEnum;
